import { addDocument, addDocumentAttachment, getDocuments, getDetailDocument, getDocSharedWithMe, editDocument, deleteDocument, addComment, getFilterDocuments, rateDocument, updateDocumentAttachment, attachmentView, getUnkerPreparing, getSatkerByUnkerPreparing, updateStateDocument, getDocumentCounter } from '@crema/services/apis/repository';
import { appIntl } from '@crema/utility/helper/Utils';
import {
    FETCH_ERROR,
    FETCH_SUCCESS,
    FETCH_START,
    GET_DOCUMENTS,
    ADD_DOCUMENT_ATTACHMENT,
    ADD_DOCUMENT,
    GET_DETAIL_DOCUMENT,
    DELETE_DOCUMENT_ATTACHMENT,
    ADD_COMMENT,
    GET_DOC_SHARED_WITH_ME,
    GET_FOLDER_PAGE,
    EDIT_DOCUMENT,
    SHOW_MESSAGE,
    DELETE_ALL_DOCUMENT_ATTACHMENT,
    DELETE_DOCUMENT,
    GET_FILTER_SEARCH,
    GET_FILTER_LIST,
    RATE_DOCUMENT,
    UPDATE_DOCUMENT_ATTACHMNET,
    ATTACHMNET_VIEW,
    SET_LASTPATH,
    GET_UNKER_PREPARING,
    GET_SATKER_PREPARING,
    ADD_ATTACHMENT_COMMENT,
    DELETE_ATTACHMENT_COMMENT,
    DELETE_ALL_ATTACHMENT_COMMENT,
    GET_DOCUMENT_COUNTER
} from 'shared/constants/ActionTypes';

export const onGetDocuments = (page, filter, publicState = false, general = '', byTitle = false, unker = '', satker = '', documentType = 'dokumen_drive') => {
    const { messages } = appIntl();
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        dispatch({ type: GET_DOCUMENTS, payload: {} })
        getDocuments(page, filter, publicState, general, byTitle, unker, satker, documentType)
            .then((data) => {
                if (data.success) {
                    dispatch({ type: GET_DOCUMENTS, payload: data })
                    dispatch({ type: FETCH_SUCCESS })
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: messages['message.somethingWentWrong'],
                    });
                }
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    };
};

export const onGetDocSharedWithMe = (page, type = '', general = '', documentType = 'dokumen_drive') => {
    const { messages } = appIntl();
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        dispatch({ type: GET_DOC_SHARED_WITH_ME, payload: {} })
        getDocSharedWithMe(page, type, documentType, general)
            .then((data) => {
                if (data.success) {
                    dispatch({ type: FETCH_SUCCESS })
                    dispatch({ type: GET_DOC_SHARED_WITH_ME, payload: data })
                } else {
                    dispatch({ type: FETCH_ERROR, payload: messages['message.somethingWentWrong'] })
                }
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.message })
            })
    }
}

export const onFilterDocument = (type, value, published = true, publicState = false, byTitle = false, unker = '', satker = '', filter = '', documentType = 'dokumen_drive') => {
    const { messages } = appIntl();
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        dispatch({ type: GET_FILTER_SEARCH, payload: {} })
        getFilterDocuments(type, value, published, publicState, byTitle, unker, satker, filter, documentType)
            .then((data) => {
                if (data.success) {
                    dispatch({ type: FETCH_SUCCESS })
                    dispatch({ type: GET_FILTER_SEARCH, payload: data })
                } else {
                    dispatch({ type: FETCH_ERROR, payload: messages['message.somethingWentWrong'] })
                }
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.message })
            })
    }
}

export const onAddDocumentAttachment = (type, file) => {
    const { messages } = appIntl();
    return (dispatch) => {
        if (type === 'onDrop') {
            dispatch({ type: FETCH_START });
            addDocumentAttachment(file)
                .then((data) => {
                    if (data.success) {
                        dispatch({ type: FETCH_SUCCESS })
                        dispatch({ type: ADD_DOCUMENT_ATTACHMENT, payload: data.result })
                        dispatch({ type: SHOW_MESSAGE, payload: 'Lampiran Berhasil Ditambahkan' })
                    } else {
                        dispatch({
                            type: FETCH_ERROR,
                            payload: messages['message.somethingWentWrong'],
                        });
                    }
                })
                .catch((error) => {
                    dispatch({ type: FETCH_ERROR, payload: 'Ukuran File Lampiran Terlalu Besar ' + error });
                })
        } else {
            dispatch({ type: ADD_DOCUMENT_ATTACHMENT, payload: file })
        }
    };
}

export const onDeleteAttachment = (data) => {
    return (dispatch) => dispatch({ type: DELETE_DOCUMENT_ATTACHMENT, payload: data });
};

export const onDeleteAllAttachment = () => {
    return (dispatch) => dispatch({ type: DELETE_ALL_DOCUMENT_ATTACHMENT });
};

export const onAddDocument = (dataDocument, documentType = 'dokumen_drive', onSuccess) => {
    const { messages } = appIntl();
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        addDocument(dataDocument, documentType)
            .then((data) => {
                if (data.success) {
                    dispatch({ type: FETCH_SUCCESS })
                    dispatch({ type: ADD_DOCUMENT, payload: data.result })
                    if (dataDocument.published) {
                        dispatch({ type: SHOW_MESSAGE, payload: 'Dokumen Berhasil Ditambahkan' })
                    } else {
                        dispatch({ type: SHOW_MESSAGE, payload: 'Dokumen Draft Berhasil Disimpan' })
                    }

                    if (onSuccess) {
                        setTimeout(() => {
                            onSuccess()
                        }, 1500)
                    }
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: messages['message.somethingWentWrong'],
                    });
                }
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    };
}

export const onEditDocument = (id, dataDocument, navigation = undefined, onSuccess) => {
    const { messages } = appIntl();
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        editDocument(id, dataDocument)
            .then((data) => {
                if (data.success) {
                    dispatch({ type: FETCH_SUCCESS })
                    dispatch({ type: EDIT_DOCUMENT, payload: data.result })
                    if (dataDocument.published) {
                        dispatch({ type: SHOW_MESSAGE, payload: 'Dokumen Berhasil Diproses' })
                    } else {
                        dispatch({ type: SHOW_MESSAGE, payload: 'Dokumen Draft Berhasil Diubah' })
                    }
                    if (navigation !== undefined) navigation()

                    if (onSuccess) {
                        setTimeout(() => {
                            onSuccess()
                        }, 1500)
                    }
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: messages['message.somethingWentWrong'],
                    });
                }
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    };
}

export const onGetDetailDocument = (id) => {
    const { messages } = appIntl();
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        dispatch({ type: GET_DETAIL_DOCUMENT, payload: null });
        getDetailDocument(id)
            .then((data) => {
                if (data.success) {
                    dispatch({ type: FETCH_SUCCESS });
                    dispatch({ type: GET_DETAIL_DOCUMENT, payload: data.result });
                } else {
                    dispatch({ type: FETCH_ERROR, payload: messages['message.somethingWentWrong'] })
                }
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    };
};

export const onResetDetailDocument = () => {
    return (dispatch) => {
        dispatch({ type: GET_DETAIL_DOCUMENT, payload: null });
    };
};

export const onAddComment = (payload, newDetailDoc, setToogleComment = undefined, setRefresh = undefined) => {
    const { messages } = appIntl();
    return (dispatch) => {
        dispatch({ type: FETCH_START })
        addComment(payload)
            .then(data => {
                if(!setRefresh){
                    const newComment = {
                        id: data.result.id,
                        message: data.result.message,
                        creator_avatar: data.result.creator_avatar,
                        creator: data.result.creator,
                        created_at: data.result.created_at,
                        is_creator: data.result.is_creator,
                        child: data.result.children
                    };
    
                    const index = newDetailDoc.comments.findIndex(item => {
                        return item.id === data.result.id
                    })
    
                    if (payload.parent_id === '') {
                        newDetailDoc.comments.unshift(newComment);
                    } else {
                        newDetailDoc.comments.splice(index, 1, newComment)
                    }
                }

                if (data.success) {
                    dispatch({ type: SHOW_MESSAGE, payload: 'Komentar Berhasil Ditambahkan' })

                    setTimeout(() => {
                        if (setRefresh) setRefresh(true);
                        // dispatch({ type: ADD_COMMENT, payload: newDetailDoc })
                        if (setToogleComment) setToogleComment(false);
                    }, 1500)
                } else {
                    dispatch({ type: FETCH_ERROR, payload: messages['message.somethingWentWrong'] })
                }
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    }
}

export const onGetFolderPage = (param) => {
    return (dispatch) => {
        dispatch({ type: GET_FOLDER_PAGE, payload: param })
    }
}

export const onSetLastPath = (param) => {
    return (dispatch) => {
        dispatch({ type: SET_LASTPATH, payload: param })
    }
}

export const onDeleteDocument = (id, setIsRefresh = undefined) => {
    const { messages } = appIntl();
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        deleteDocument(id)
            .then((data) => {
                if (data.success) {
                    dispatch({ type: FETCH_SUCCESS });
                    dispatch({ type: DELETE_DOCUMENT });
                    dispatch({ type: SHOW_MESSAGE, payload: 'Dokumen Berhasil Dihapus' })
                    if (setIsRefresh) setIsRefresh(true);
                } else {
                    dispatch({ type: FETCH_ERROR, payload: messages['message.somethingWentWrong'] })
                }
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    };
}

export const onChangeFilterList = (param) => {
    return (dispatch) => {
        dispatch({ type: GET_FILTER_LIST, payload: param })
    }
}

export const onRateDocument = (id, payload, setRefresh) => {
    const { messages } = appIntl();
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        rateDocument(id, payload)
            .then((data) => {
                if (data.success) {
                    dispatch({ type: RATE_DOCUMENT })
                    dispatch({ type: FETCH_SUCCESS })
                    dispatch({ type: SHOW_MESSAGE, payload: 'Penilaian Berhasil Ditambahkan' })
                    setRefresh(true)
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: messages['message.somethingWentWrong'],
                    });
                }
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    };
}

export const onUpdateAttachment = (id, file, setRefresh) => {
    const { messages } = appIntl();
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        updateDocumentAttachment(id, file)
            .then((data) => {
                if (data.success) {
                    dispatch({ type: UPDATE_DOCUMENT_ATTACHMNET })
                    dispatch({ type: FETCH_SUCCESS })
                    dispatch({ type: SHOW_MESSAGE, payload: 'Lampiran Berhasil Diubah' })
                    setRefresh(true)
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: messages['message.somethingWentWrong'],
                    });
                }
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    };
}

export const onAttachmentView = (id) => {
    const { messages } = appIntl();
    return (dispatch) => {
        attachmentView(id)
            .then((data) => {
                if (data.success) {
                    dispatch({ type: ATTACHMNET_VIEW })
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: messages['message.somethingWentWrong'],
                    });
                }
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    };
}

export const onGetUnkerPreparing = () => {
    const { messages } = appIntl();
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        getUnkerPreparing()
            .then((data) => {
                if (data.success) {
                    dispatch({ type: GET_UNKER_PREPARING, payload: data.results })
                    dispatch({ type: FETCH_SUCCESS })
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: messages['message.somethingWentWrong'],
                    });
                }
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    };
};

export const onGetSatkerByUnkerPreparing = (id) => {
    const { messages } = appIntl();
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        getSatkerByUnkerPreparing(id)
            .then((data) => {
                if (data.success) {
                    dispatch({ type: GET_SATKER_PREPARING, payload: data.results })
                    dispatch({ type: FETCH_SUCCESS })
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: messages['message.somethingWentWrong'],
                    });
                }
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    };
};

export const onUpdateStateDocument = (id, payload, navigation = undefined) => {
    const { messages } = appIntl();
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        updateStateDocument(id, payload)
            .then((data) => {
                if (data.success) {
                    dispatch({ type: FETCH_SUCCESS })
                    dispatch({ type: SHOW_MESSAGE, payload: `Data Berhasil  ${payload.action === 'approve' ? 'Disetujui' : 'Ditolak'}` })
                    if (navigation !== undefined) {
                        setTimeout(() => {
                            navigation()
                        }, 3000)
                    }
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: messages['message.somethingWentWrong'],
                    });
                }
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    };
}

export const onAddAttachmentComment = (file) => {
    const { messages } = appIntl();
    return (dispatch) => {
        dispatch({ type: FETCH_START });
        addDocumentAttachment(file)
            .then((data) => {
                if (data.success) {
                    dispatch({ type: FETCH_SUCCESS })
                    dispatch({ type: ADD_ATTACHMENT_COMMENT, payload: data.result })
                } else {
                    dispatch({
                        type: FETCH_ERROR,
                        payload: messages['message.somethingWentWrong'],
                    });
                }
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: 'Ukuran File Lampiran Terlalu Besar ' + error });
            })
    };
}

export const onDeleteAttachmentComment = (data) => {
    return (dispatch) => dispatch({ type: DELETE_ATTACHMENT_COMMENT, payload: data });
};

export const onDeleteAllAttachmentComment = () => {
    return (dispatch) => dispatch({ type: DELETE_ALL_ATTACHMENT_COMMENT });
};

export const onGetDocumentCounter = (type) => {
    const { messages } = appIntl();
    return (dispatch) => {
        getDocumentCounter(type)
            .then((data) => {
                if (data.success) {
                    dispatch({ type: GET_DOCUMENT_COUNTER, payload: data.result });
                } else {
                    dispatch({ type: FETCH_ERROR, payload: messages['message.somethingWentWrong'] })
                }
            })
            .catch((error) => {
                dispatch({ type: FETCH_ERROR, payload: error.message });
            })
    };
};